import React from "react";
import HeaderSection from "../../components/header";
import CommonHeroSection from "../../components/CommonHeroSection/CommonHeroSection";
import Footer from "../../components/footerSection";
import image2 from "../../assets/electricbgimage.png";
import ContactUsSection from "../../components/servicesSection/ContactUsSection";
import GallarySection from "./GallarySection";
import gImg from "../../assets/electricfireplaceimg.png";
import gImg1 from "../../assets/electricinsertimg.png";
import WhyChooseSection from "./WhyChooseSection";
import './service.css'

export default function ServicePageElectric() {
  let gallaryData = [
    {
      gallaryImg: gImg,
      headText: `Electric`,
      highlightText: `Fireplace`,
      extraText: `Electric Fireplaces It comes in various styles, from 
            mantel packages to wall-mounted units. They feature 
            realistic flame effects generated by LED technology,
            along with adjustable heat settings that allow 
            homeowners to control the temperature to their liking. 
            They are easy to install and can be placed in any room, 
            making them an ideal choice for apartments, condos, 
            or homes without existing chimneys.`,
      gallaryImg1: gImg1,
      headText1: `Electric`,
      highlightText1: `Inserts`,
      extraText1: `Electric Inserts These are designed to retrofit into existing 
            fireplaces, converting them into electric heating sources. 
            They are easy to install and operate, making them a 
            cost-effective and low-maintenance alternative to 
            traditional wood or gas inserts. Plus, they can be used 
            with or without heat, allowing homeowners to enjoy the 
            visual appeal of a fire year round.`,
    },
  ];

  let titlesBox = [
    "Customizable",
    "Easy Installation",
    "Minimal Maintenance",
    "Safest Option",
  ];
  return (
    <div>
      <HeaderSection />
      <CommonHeroSection
        imgName={image2}
        titleHead="Electric"
        extraContent={`Home > Our Services >Electric`}
      />

      <GallarySection
        gallaryImg={gallaryData[0]?.gallaryImg}
        extraContent={gallaryData[0]?.extraText}
        secSent={gallaryData[0]?.highlightText}
        firstSent={gallaryData[0]?.headText}
        gallaryImg1={gallaryData[0]?.gallaryImg1}
        extraContent1={gallaryData[0]?.extraText1}
        secSent1={gallaryData[0]?.highlightText1}
        firstSent1={gallaryData[0]?.headText1}
      />

      <WhyChooseSection
        firstSent={"Why Choose"}
        secSent={"Electric Flame?"}
        titlesBox={titlesBox}
      />

      <ContactUsSection />

      <Footer />
    </div>
  );
}
